import { useApolloClient } from "@apollo/client";
import React from "react";
import type { ModifyItemEstimatedCalculationValuesInput } from "../../../../clients/graphqlTypes.js";
import { useModifyItemEstimatedCalculationMutation } from "../../doc-items/CalculationMutations.generated.js";

interface Options {
  projectId: string;
  docId: string;
}

export type ModifyItemCalculationFn = (
  itemId: string,
  values: Partial<ModifyItemEstimatedCalculationValuesInput>
) => Promise<void>;

export function useModifyItemCalculation({ projectId, docId }: Options) {
  const client = useApolloClient();
  const [modifyItem] = useModifyItemEstimatedCalculationMutation({ client });

  const modifyItemCalculation: ModifyItemCalculationFn = React.useCallback(
    async (
      itemId: string,
      values: Partial<ModifyItemEstimatedCalculationValuesInput>
    ) => {
      const result = await modifyItem({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            values,
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not modify item");
      }
    },
    [modifyItem, projectId, docId]
  );

  return { modifyItemCalculation };
}
